import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CalendarComponentOptions } from 'ion4-calendar';
import * as moment from 'moment';
import { ModalController, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.scss'],
})
export class CalendarioComponent {

  @Input() tipo: string;
  @Output() selectedDateEvent = new EventEmitter();

  optionsRange: CalendarComponentOptions = {
    monthPickerFormat: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    weekdays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    monthFormat: 'MMMM YYYY',
    from: new Date(1),
  };

  constructor(
    private poopverCtrl: PopoverController
  ) {
    moment.locale('pt-br');
  }

  onChange($event) {
    this.poopverCtrl.dismiss($event);
  }
}
